import { render, staticRenderFns } from "./TemplateFormular.vue?vue&type=template&id=07142f94&scoped=true&"
import script from "./TemplateFormular.vue?vue&type=script&lang=js&"
export * from "./TemplateFormular.vue?vue&type=script&lang=js&"
import style0 from "./TemplateFormular.vue?vue&type=style&index=0&id=07142f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07142f94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCol,VIcon,VRow,VSnackbar})
